import config from '../config'
import {linkFinder} from '../core/links'
import {DEFAULT_TICKET_QUERY, loadTicketStream} from '../ticket/actions'
import TicketStream from '../ticket/components/TicketStream'
import {DEFAULT_CONTACT_QUERY as DEFAULT_PROVIDER_CONTACT_QUERY, loadContactStream as loadProviderContactStream} from '../provider/actions'
import ProviderContactStream from '../provider/components/ContactStream'
import {loadReportStream as loadAuditReportStream} from '../audit/actions'
import AuditReportStream from '../audit/components/ReportStream'
import {DEFAULT_PATRIMONY_QUERY, DEFAULT_CONTACT_QUERY, loadPatrimonyStream, loadPatrimony, loadLotAndBuildingStream, loadLotStream, loadLot, loadBuilding, loadContactStream, loadContact} from './actions'
import PatrimonyLayout from './components/PatrimonyLayout'
import PatrimonyStreamLayout from './components/PatrimonyStreamLayout'
import PatrimonyDetail from './components/PatrimonyDetail'
import PatrimonyDashboard from './components/PatrimonyDashboard'
import LotStream from './components/LotStream'
import AdditionalInfos from './components/AdditionalInfos'
import LotDetail from './components/LotDetail'
import LotDashboard from './components/LotDashboard'
import BuildingDetail from './components/BuildingDetail'
import BuildingDashboard from './components/BuildingDashboard'
import ContactStream from './components/ContactStream'
import ContactDetail from './components/ContactDetail'
import ContactDashboard from './components/ContactDashboard'

function enterPatrimonyStream(getState) {
    return (dispatch) => {
        const state = getState()
        const {criteria} = state.patrimony

        return dispatch(loadPatrimonyStream({...DEFAULT_PATRIMONY_QUERY, ...criteria}))
    }
}

export function patrimonyContactRoute(rootPath, dispatcher, {getState}) {
    return {
        path: rootPath,
        component: PatrimonyLayout,
        onEnter: dispatcher(enterPatrimonyStream(getState)),
        childRoutes: [{
            path: ':id',
            component: ContactDetail,
            onEnter: dispatcher((d, p) => d(loadContact(p.id))),
            indexRoute: {
                component: ContactDashboard
            }
        }]
    }
}

export default function(rootPath, dispatcher, {getState}) {

    function enterPatrimony(dispatch, params) {
        const state = getState()
        const _appLinks = state.app._links

        return Promise.all([
            dispatch(loadPatrimony(params.id)),
            _appLinks.find(linkFinder('tickets')) && dispatch(loadTicketStream({...DEFAULT_TICKET_QUERY, patrimony: params.id, range: {offset: 0, limit: 0}})),
            config.feature.audit && dispatch(loadAuditReportStream({externalRefUid: params.id})).catch(() => {})
        ])
    }

    function enterBuilding(dispatch, params) {
        return Promise.all([
            dispatch(loadBuilding(params.id, params.bid)),
            config.feature.audit && dispatch(loadAuditReportStream({externalRefUid: params.bid})).catch(() => {})
        ])
    }

    function enterLot(dispatch, params) {
        return Promise.all([
            dispatch(loadPatrimony(params.id)),
            dispatch(loadLot(params.lid)),
            config.feature.audit && dispatch(loadAuditReportStream({externalRefUid: params.lid})).catch(() => {})
        ])
    }

    return {
        path: rootPath,
        component: PatrimonyLayout,
        onEnter: dispatcher(enterPatrimonyStream(getState)),
        indexRoute: {
            component: PatrimonyStreamLayout
        },
        childRoutes: [{
            path: ':id',
            component: PatrimonyDetail,
            onEnter: dispatcher(enterPatrimony),
            indexRoute: {
                component: PatrimonyDashboard
            },
            childRoutes: [{
                path: 'additionalinfos',
                component: AdditionalInfos,
            }, {
                path: 'lots',
                component: LotStream,
                onEnter: dispatcher((d, p) => d(loadLotAndBuildingStream(p.id)))
            }, {
                path: 'tickets',
                component: TicketStream,
                onEnter: dispatcher((d, p) => d(loadTicketStream({...DEFAULT_TICKET_QUERY, patrimony: p.id})))
            }, {
                path: 'contacts',
                component: ContactStream,
                onEnter: dispatcher((d, p) => d(loadContactStream({...DEFAULT_CONTACT_QUERY, patrimonyUids: p.id})))
            }, {
                path: 'providercontacts',
                component: ProviderContactStream,
                onEnter: dispatcher((d, p) => d(loadProviderContactStream({...DEFAULT_PROVIDER_CONTACT_QUERY, patrimonyUids: p.id})))
            }, {
                path: 'audits',
                component: AuditReportStream
            }]
        }, {
            path: ':id/buildings/:bid',
            component: BuildingDetail,
            onEnter: dispatcher(enterBuilding),
            indexRoute: {
                component: BuildingDashboard
            },
            childRoutes: [{
                path: 'lots',
                component: LotStream,
                onEnter: dispatcher((d, p) => d(loadLotStream(p.id, p.bid)))
            }, {
                path: 'audits',
                component: AuditReportStream
            }]
        }, {
            path: ':id/lots/:lid',
            component: LotDetail,
            onEnter: dispatcher(enterLot),
            indexRoute: {
                component: LotDashboard
            },
            childRoutes: [{
                path: 'contacts',
                component: ContactStream,
                onEnter: dispatcher((d, p) => d(loadContactStream({...DEFAULT_CONTACT_QUERY, lotUid: p.lid})))
            }, {
                path: 'audits',
                component: AuditReportStream
            }]
        }]
    }
}


// WEBPACK FOOTER //
// ./lib/patrimony/routes.js